module.exports = __webpack_public_path__ + "img/tweet-content.fa207a1b.jpg";